<div class="alert-centered" *ngIf="shutdownAlertFlag">
<!--    <div class="alert-text-margin"> {{ 'shutdownAlert.content' | transloco }} {{ alertDate | translocoDate: { dateStyle: 'medium' } }}-->
<!--        <a href="https://www.bulbapp.com/u/bulb-transition">{{ 'shutdownAlert.infoLink' | transloco }}</a>-->
<!--    </div>-->
<!--    <aero-button aero-style="PRIMARY" label="{{ 'shutdownAlert.confirm' | transloco }}" (click)="alertAccepted()">-->
<!--    </aero-button>-->
</div>
